import { MODE_AUTO, MODE_DARK, MODE_LIGHT } from '@/constants/theme.constant';

export const MODE_STORAGE_KEY = 'theme.mode';

const MODES = [MODE_AUTO, MODE_DARK, MODE_LIGHT];

export const readModePreference = () => {
	try {
		const stored = localStorage.getItem(MODE_STORAGE_KEY);

		return MODES.includes(stored) ? stored : null;
	} catch {
		return null;
	}
};

export const writeModePreference = mode => {
	try {
		localStorage.setItem(MODE_STORAGE_KEY, mode);
	} catch {
	}
};
